import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { MdArrowBackIosNew } from "react-icons/md";
import EAButton from "../../app/components/shared/Buttons/EAButton";
import { MAIN_APP } from "../../app/routes";
import EmbedToolbar from "./EmbedToolbar";
import { useHasEmbedPageHeader } from "./EmbedPageHeaderContext";
import "./embedNavigation.scss";

const SHOP_START = MAIN_APP || "/";

/** Pasek dla stron bez nagłówka (koszyk, konto, logowanie): powrót do oferty i pasek narzędzi. */
const EmbedNavBar: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const hasPageHeader = useHasEmbedPageHeader();

  if (hasPageHeader) return null;

  const isShopStart = location.pathname === SHOP_START || location.pathname === `${MAIN_APP}/`;

  return (
    <div className="embed-navbar">
      {!isShopStart && (
        <EAButton
          title={t("wroc_do_sklepu")}
          onClick={() => navigate(SHOP_START)}
          startIcon={<MdArrowBackIosNew />}
          variant="text"
          noMargins
        />
      )}
      <EmbedToolbar />
    </div>
  );
};

export default EmbedNavBar;
